import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModulosDeFormulario } from 'src/app/utils/formsModules';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ListaNegociosComponent } from './lista-negocios.component';



@NgModule({
  declarations: [ListaNegociosComponent],
  imports: [
    CommonModule,
    ModulosDeFormulario,
    MatTooltipModule
  ],
  exports: [ListaNegociosComponent]
})
export class ListaNegociosModule { }
